module.exports = __webpack_public_path__ + "img/placeholder_3.eb044562.svg";